import { useCallback, useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { toast } from "react-toastify"

import Layout from "../../layouts/layout"
import MainPageLayout from "../../components/main-page-layout/mainPageLayout"
import { useDropzone } from "react-dropzone"
import { DateTimePicker } from "react-advance-jalaali-datepicker"
import { useRequestProcessor } from "../../api/requestProcessor"
import { uploadImage, uploadVideo } from "../../api/upload-files"
import { getSingleWorkshop, storeSingleWorkshops, updateSingleWorkshops } from "../../api/workshops"
import Loading from "../../components/loading/loading"
import { getAllProvinces, getProvinceCities } from "../../api/city-province"
import { domainName } from "../../constants/site"

import makeAnimated from 'react-select/animated';
import Select from "react-select"
import { getAllCategoriesWithType } from "../../api/categories"

import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import { getSingleCourse, updateSingleCourse } from "../../api/course"



const Require = () => {
    return <span className="text-red-500">*</span>
}

const EditCourse = () => {

    const [name, setName] = useState("")
    const [level, setLevel] = useState([{ label: "مقدماتی", value: "مقدماتی" }, { label: "پیشرفته", value: "پیشرفته" }])
    const [statusData, setStatusData] = useState([{ label: "فعال", value: "active" }, { label: "غیر فعال", value: "inactive" }, { label: "بایگانی", value: "is_draft" }])
    const [status, setStatus] = useState({})
    const [period, setPeriod] = useState("")
    const [price, setPrice] = useState(0)
    const [discount, setDiscount] = useState(0)
    const [episodes, setEpisodes] = useState("")
    const [sections, setSections] = useState("")
    const [selectedLevel, setSelectedLevel] = useState("")
    const [spotPlayerID, setSpotPlayerID] = useState("")
    const [isVideo, setIsVideo] = useState(true)
    const [bannerUrl, setBannerUrl] = useState("")
    const [coverUrl, setCoverUrl] = useState("")
    const [videoData, setVideoData] = useState({
        url: "",
        extenstion: ""
    })
    const [aparatUrl, setAparatUrl] = useState("")
    const [selectedCategory, setSelectedCategory] = useState([])
    const [supportWay, setSupportWay] = useState("")
    const [deliverWay, setDeliverWay] = useState("")
    const [prerequisite, setPrerequisite] = useState("")
    const [description, setDescription] = useState("")

    const [convertedContent, setConvertedContent] = useState(null);


    const { course_id } = useParams()
    const navigate = useNavigate()

    const { Query, Mutate } = useRequestProcessor()


    const { data: courseData, isLoading } = Query(
        ["getSingleCourse", course_id],
        () => getSingleCourse(course_id)
    )


    const { mutate: mutateCourse } = Mutate(
        "updateSingleCourse",
        updateSingleCourse,
        {
            onSuccess: (data) => {
                toast.success(data.message + " تا چند ثانیه دیگر به صفحه اصلی منتقل خواهید شد.", {
                    autoClose: 2500,
                    progress: false,
                })
                setTimeout(() => { navigate("/admin/course") }, 3000)
                //This is the response you get back
            }
            ,
            onError: (data) => {
                toast.error(data.response.data.message)
            }
        }
    );
    const { data: categoryData, isLoading: discountLoading, refetch } = Query(
        ['getAllCategoryByType', "courses"],
        () => getAllCategoriesWithType("courses")
    );


    const { mutate: mutateBanner } = Mutate(
        "uploadBannerImage",
        uploadImage,
        {
            onSuccess: (data) => {
                successfulHandler(data) //This is the response you get back
            }
            ,
            onError: (data) => {
                toast.error(data.response.data.message)
            }
        }
    );

    const { mutate: mutateCover } = Mutate(
        "uploadCoverImage",
        uploadImage,
        {
            onSuccess: (data) => {
                toast.success("عکس با موفقیت آپلود شد", {
                    autoClose: 2500,
                    progress: false,
                })
                setCoverUrl(data.images.thumb)
                //This is the response you get back
            }
            ,
            onError: (data) => {
                toast.error(data.response.data.message)
            }
        }
    );
    const { mutate: mutateVideo } = Mutate(
        "uploadVideo",
        uploadVideo,
        {
            onSuccess: (data) => {
                toast.success("ویدیو با موفقیت آپلود شد", {
                    autoClose: 2500,
                    progress: false,
                })
                setVideoData({ url: data.data.filePath, extenstion: data.data.fileExtension })
                //This is the response you get back
            }
            ,
            onError: (data) => {
                toast.error(data.response.data.message)
            }
        }
    );


    // DROPZONE CONFIG


    const onDropThumb = useCallback(acceptedFiles => {
        let formData = new FormData();
        formData.append("images", acceptedFiles[0])
        mutateBanner(formData)
    }, [])

    const onDropCover = useCallback(acceptedFiles => {
        let formData = new FormData();
        formData.append("images", acceptedFiles[0])
        mutateCover(formData)
    }, [])
    const onDropVideo = useCallback(acceptedFiles => {
        let formData = new FormData();
        formData.append("video", acceptedFiles[0])
        mutateVideo(formData)
    }, [])


    const { getRootProps: getThumbRootprops, getInputProps: getThumbInputProps, isDragActive: isThumbDragActive } = useDropzone({
        onDrop: onDropThumb, maxFiles: 1, multiple: false, accept: {
            'image/jpeg': [],
            'image/jpg': [],
            'image/png': [],
        }
    });
    const { getRootProps: getCoverRootprops, getInputProps: getCoverInputProps, isDragActive: isCoverDragActive } = useDropzone({
        onDrop: onDropCover, maxFiles: 1, multiple: false, accept: {
            'image/jpeg': [],
            'image/jpg': [],
            'image/png': [],
        }
    });
    const { getRootProps: getVideoRootprops, getInputProps: getVideoInputProps, isDragActive: isVideoDragActive } = useDropzone({
        onDrop: onDropVideo, maxFiles: 1, multiple: false, accept: {
            'video/*': [],
        }
    });



    function onDescriptionHandler(event) {
        setDescription(event.target.value)
    }

    function successfulHandler(res) {
        setBannerUrl(res.images.thumb);
        toast.success(res.message)
    }

    async function onSubmitHandler(e) {
        e.preventDefault();
        let newData = {
            id: course_id,
            data: {
                title: name,
                price: price,
                time: period,
                category_id: selectedCategory.length ? selectedCategory?.map(el => el.value) : null,
                description: description,
                level: selectedLevel.length ? selectedLevel[0]?.label : '',
                discount: discount ?? null,
                body: convertedContent,
                status: status.value,
                spotplayer_course_id: spotPlayerID,
                banner: {
                    thumb: bannerUrl
                },
                cover_image: {
                    thumb: coverUrl
                },
                prerequisite: prerequisite ?? "",
                delivery_way: deliverWay ?? "",
                support_way: supportWay ?? "",
                section_count: sections,
                episode_count: episodes,
                video_type: isVideo ? "video" : "aparat",
                video: isVideo ?
                    {
                        filePath: videoData.url ? { path: videoData.url } : null,
                        fileExtension: videoData.extenstion ?? null
                    } :
                    {
                        htmlCode: aparatUrl ?? null
                    }
                ,
            }
        }
        if (period.split(':').length - 1 < 2) {
            toast.error("فرمت زمان دوره اشتباه است", {
                autoClose: 2000
            })
        }
        else if (period.length > 8 || period.length < 7) {
            toast.error("فرمت زمان دوره اشتباه است", {
                autoClose: 2000
            })
        }
        else {
            mutateCourse(newData)
        }
    }

    function propertiesHandler(data) {

        setName(data?.data?.title)
        setPeriod(data?.data?.time)
        setPrice(data?.data?.price)
        setDescription(data?.data?.description)
        setConvertedContent(data?.data?.body)
        setSelectedLevel({ label: data?.data?.level, value: data?.data?.level })
        setEpisodes(data?.data?.episode_count)
        setSections(data?.data?.section_count)
        setSupportWay(data?.data?.support_way)
        setSpotPlayerID(data?.data?.spotplayer_course_id)
        setPrerequisite(data?.data?.prerequisite)
        setDeliverWay(data?.data?.delivery_way)
        setSelectedCategory(data?.data?.categories.map(el => ({ label: el.title, value: el.id })))
        switch (data?.data?.status) {
            case "active":
                setStatus({ label: "فعال", value: "active" })
                break;
            case "isactive":
                setStatus({ label: "غیر فعال", value: "inactive" })
                break;
            case "is_draft":
                setStatus({ label: "بایگانی", value: "is_draft" })
                break;

            default:
                setStatus({ label: "بایگانی", value: "is_draft" })
                break;
        }
        data?.data?.files.forEach(key => {
            if (key.type === "cover") {
                setCoverUrl(key.file.thumb)
            }
            else if (key.type === "banner") {
                setBannerUrl(key.file.thumb)
            }
            else if (key.type === "aparat") {
                setAparatUrl(key.file.htmlCode)
                setIsVideo(false)
            }
            else if (key.type === "video") {
                setIsVideo(true)
                setVideoData({ url: key?.file?.path })
            }
        });
    }

    useEffect(() => {
        propertiesHandler(courseData)
    }, [courseData])



    function handleOnChange(data) {
        setSelectedCategory(data[0].value)
    }

    const animatedComponents = makeAnimated();

    if (isLoading) return <Loading />

    return (
        <Layout >
            <MainPageLayout backButton sectionTitle={"مشخصات دوره :"} title={"تصحیح دوره"} >
                <form onSubmit={onSubmitHandler}>
                    <div className="flex wsm:flex-col">
                        <div className='flex flex-col my-4 w-full'>
                            <div className='flex flex-col my-3 ml-4 '>
                                <p className='pr-3 pb-1'>نام دوره :<Require /></p>
                                <input type="text" value={name} onChange={(e) => setName(e.target.value)} className=' form-input !w-full' placeholder='نام دوره' />
                            </div>
                            <div className='flex flex-col my-3 ml-4'>
                                <p className='pr-3 pb-1'>سرفصل و قسمت های دوره :<Require /></p>
                                <div className="flex">
                                    <input type="text" value={sections} onChange={(e) => setSections(e.target.value)} className=' form-input ml-4' placeholder='سرفصل ها' />
                                    <input type="text" value={episodes} onChange={(e) => setEpisodes(e.target.value)} className=' form-input' placeholder='قسمت ها' />
                                </div>
                            </div>
                            <div className='flex flex-col my-3'>
                                <p className='pr-3 pb-1'>مدت زمان برگزاری : (به همراه نوع زمان)<Require /></p>
                                <input type="text" value={period} onChange={(e) => setPeriod(e.target.value)} className=' form-input' placeholder='مدت زمان' />
                            </div>

                            <div className='flex flex-col my-3'>
                                <p className='pr-3 pb-1'>قیمت دوره :<Require /></p>
                                <input type="number" value={price} onChange={(e) => setPrice(e.target.value)} className=' form-input' placeholder='قیمت دوره' />
                            </div>
                            <div className='flex flex-col my-3'>
                                <p className='pr-3 pb-1'>مقدار تخفیف :<span className=" text-gray-500">( ساخته نشده )</span></p>
                                <input type="number" value={discount} onChange={(e) => setDiscount(e.target.value)} disabled className=' form-input' placeholder='قیمت تخفیف' />
                            </div>
                            <div className='flex flex-col my-3 ml-4'>
                                <p className='pr-3 pb-1'>انتخاب دسته بندی :</p>
                                <Select components={animatedComponents} placeholder="انتخاب کنید..."
                                    onChange={handleOnChange} closeMenuOnSelect={false} value={selectedCategory}
                                    isMulti options={categoryData?.data?.map(el => ({ label: el.title, value: el.id }))}

                                />
                            </div>
                            <div className='flex flex-col my-3 ml-4'>
                                <p className='pr-3 pb-1'>توضیح دوره:</p>
                                <div className='flex form-input !w-full items-center '>
                                    <input value={description} onChange={onDescriptionHandler} type="text" className='form-input !w-full' placeholder='توضیح مختصر درباره دوره ' />
                                    <div className={`flex basis-1/4 justify-center border ${description?.length > 180 ? "!bg-red-500 text-white" : "text-green-500"} border-black rounded-xl py-2 mr-2 bg-white`}>180 / {description?.length} </div>
                                </div>
                            </div>
                            <div className='flex flex-col my-3'>
                                <p className='pr-3 pb-1'>نحوه پشتیبانی :</p>
                                <input type="text" value={supportWay} onChange={(e) => setSupportWay(e.target.value)} className=' form-input !w-3/4' placeholder='نحوه پشتیبانی' />
                            </div>
                            <div className='flex flex-col my-3'>
                                <p className='pr-3 pb-1'>پشنیاز دوره :</p>
                                <input type="text" value={prerequisite} onChange={(e) => setPrerequisite(e.target.value)} className=' form-input !w-3/4' placeholder='پیشنیاز دوره' />
                            </div>
                        </div>
                        <div className="w-full my-4 flex flex-col">

                            <div className="flex flex-col mb-4">
                                <p className='pr-3 pb-1'>انتخاب عکس بنر :<Require /></p>

                                <form id='recommendationDiv' className="flex justify-center h-full items-center border border-dashed py-5 bg-gray-100 cursor-pointer rounded-2xl hover:border-sky-600" {...getThumbRootprops()}>
                                    <input
                                        {...getThumbInputProps()} />
                                    {
                                        <p> فایل را انتخاب یا به اینجا بکشید</p>
                                    }
                                </form>
                                <div className="flex justify-center my-4">
                                    <img src={bannerUrl && domainName + bannerUrl} className="w-[150px]" alt="" />
                                </div>
                            </div>

                            <div className="flex flex-col mb-4">
                                <p className='pr-3 pb-1'>انتخاب عکس کاور :<Require /></p>

                                <form className="flex justify-center h-full items-center border border-dashed py-5 bg-gray-100 cursor-pointer rounded-2xl hover:border-sky-600" {...getCoverRootprops()}>
                                    <input
                                        {...getCoverInputProps()} />
                                    {
                                        <p> فایل را انتخاب یا به اینجا بکشید</p>
                                    }
                                </form>
                                <div className="flex justify-center my-4">
                                    <img src={coverUrl && domainName + coverUrl} className="w-[150px]" alt="" />
                                </div>
                            </div>
                            <div className="flex flex-col mb-4">
                                <div className="flex justify-between text-center items-center">
                                    <p className='pr-3 pb-1'>انتخاب ویدیو دوره :<Require /></p>
                                    <div className="mx-10 items-center flex wsm:!mx-0 m-2">
                                        <p>آپارات</p>
                                        <label class="relative inline-flex  cursor-pointer mx-2">
                                            <input type="checkbox" checked={!isVideo} onChange={(e) => setIsVideo(prev => !prev)} class="sr-only peer" />
                                            <div class={`w-11 h-6  rounded-full peer bg-sky-300  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all `}></div>
                                        </label>
                                        <p>فایل ویدیو</p>
                                    </div>
                                </div>
                                {
                                    isVideo ?
                                        <form className="flex justify-center h-full items-center border border-dashed py-5 bg-gray-100 cursor-pointer rounded-2xl hover:border-sky-600" {...getVideoRootprops()}>
                                            <input
                                                {...getVideoInputProps()} />
                                            {
                                                <p> فایل را انتخاب یا به اینجا بکشید</p>
                                            }
                                        </form>
                                        :
                                        <div className='flex flex-col my-3'>
                                            <p className='pr-3 pb-1'>لینک کد آپارات :</p>
                                            <input type="text" value={aparatUrl} onChange={(e) => setAparatUrl(e.target.value)} className=' form-input !w-full' placeholder='لینک را جایگذاری کنید' />
                                        </div>
                                }
                                <div className="flex justify-center my-4">
                                    <video src={videoData.url && domainName + videoData.url.substring(1)} className="w-[150px]" alt="" />
                                </div>
                            </div>


                            <div className='flex flex-col my-3'>
                                <p className='pr-3 pb-1'>انتخاب سطح :</p>
                                <Select components={animatedComponents} placeholder="انتخاب کنید..."
                                    onChange={(data) => setSelectedLevel(data.label)} closeMenuOnSelect={true}
                                    options={level} value={selectedLevel}

                                />
                            </div>
                            <div className='flex flex-col my-3'>
                                <p className='pr-3 pb-1'>شناسه اسپات پلیر :</p>
                                <input type="text" value={spotPlayerID} onChange={(e) => setSpotPlayerID(e.target.value)} className=' form-input !w-3/4' placeholder='شناسه اسپات پلیر ' />
                            </div>
                            <div className='flex flex-col my-3'>
                                <p className='pr-3 pb-1'>نحوه ارسال :</p>
                                <input type="text" value={deliverWay} onChange={(e) => setDeliverWay(e.target.value)} className=' form-input !w-3/4' placeholder='نحوه ارسال' />
                            </div>
                            <div className='flex flex-col my-3'>
                                <p className='pr-3 pb-1'>وضعیت دوره :</p>
                                <Select components={animatedComponents} placeholder="انتخاب کنید..."
                                    onChange={(data) => setStatus(data)} closeMenuOnSelect={true}
                                    options={statusData} value={status}

                                />
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-col my-3">
                        <p className='pr-3 pb-1'>متن دوره :</p>
                        <CKEditor
                            editor={ClassicEditor}
                            data={convertedContent ?? ""}
                            config={{
                                language: {
                                    ui: "en",
                                    content: "ar"
                                }
                            }}

                            onChange={(event, editor) => {
                                const data = editor.getData();
                                setConvertedContent(data);
                            }}

                        />
                    </div>
                    <p className='pr-3 text-sm'>متاتگ های وبسایت بر اساس کلمات نوشته شما ساخته میشود</p>

                    <div id='form-add-button--container'>
                        <button type="submit" id='form-add-button'>ثبت</button>
                    </div>
                </form>
            </MainPageLayout>
        </Layout>
    )
}

export default EditCourse